import axiosService from '../axios.service';

const ageGroupDataService = {

    get(status) {
        return new Promise((resolve) => {
            axiosService.api.get(`/ageGroup?status=${status}`)
                .then(response => {
                    resolve(response.data);
                })
        })
    },
}

export default ageGroupDataService